import { render, staticRenderFns } from "./SpaceConfiguration.vue?vue&type=template&id=72ddc398&"
import script from "./SpaceConfiguration.vue?vue&type=script&lang=js&"
export * from "./SpaceConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports